const bannerUtils = {
  toImage: (src: string, href = null) => ({
    src,
    href,
    type: 'image',
  }),
};

export const en = {
  entry: {
    to_exhibition_hall: 'Enter Exhibition Hall',
    how_to_use_oms: '<b>How to utilize</b><b>virtual expo?</b>',
  },
  banners: {
    left: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/24a288b0-63cf-42a4-b138-5503c93f995e.png',
      ),
    ],
    right: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/24a288b0-63cf-42a4-b138-5503c93f995e.png',
      ),
    ],
    middle: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/24a288b0-63cf-42a4-b138-5503c93f995e.png',
        'https://www.japan-mfg-nagoya.jp/en/',
      ),
    ],
    mobile: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/24a288b0-63cf-42a4-b138-5503c93f995e.png',
        'https://www.japan-mfg-nagoya.jp/en/',
      ),
    ],
  },
};

export const ja = {
  entry: {
    to_exhibition_hall: '展示会場はこちら',
    how_to_use_oms: '<b>はじめに</b><i>オンライン来場・商談サービスの使い方</i>',
  },
  banners: {
    left: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/cbf9e60a-6b87-4fc5-8d64-69731f97b177.png',
      ),
    ],
    right: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/cbf9e60a-6b87-4fc5-8d64-69731f97b177.png',
      ),
    ],
    middle: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/cbf9e60a-6b87-4fc5-8d64-69731f97b177.png',
        'https://www.japan-mfg-nagoya.jp/',
      ),
    ],
    mobile: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/cbf9e60a-6b87-4fc5-8d64-69731f97b177.png',
        'https://www.japan-mfg-nagoya.jp/',
      ),
    ],
  },
};
